import React from 'react'

function Error() {
  return (
    <div>Please enter a valid word</div>
  )
}

export default Error